import React from 'react'

import { Element, ElementProps, Text } from "components/shared/base"
import {
  PrismicHomepageDataBodyTwoColumnItem
} from "types/__generated__/gatsby-graphql"

interface OwnProps {
  index: number
  item:  PrismicHomepageDataBodyTwoColumnItem
}

export type TwoColumnItemProps = OwnProps & Omit<ElementProps, "errors">

const TwoColumnItem: React.FC<TwoColumnItemProps> = ({
  index,
  item: { 
    item_text,
    item_title
  },
  ...elementProps
}): React.ReactElement | null => {

  const headlineText = item_title?.text || "";
  // Use 1 for first item instead of 0 for isEven
  const isEven = (index + 1) % 2 === 0;
  const gridColStartMdAndAbove = isEven ? "8" : "1";

  return (
    <Element
      fontSize={["text.primaryMobile", "text.primary"]}
      gridColumnEnd={["span 12", "span 5"]}
      gridColumnStart={["1", gridColStartMdAndAbove ]}
      lineHeight="164%"
      mt={["40px", "60px"]}
      {...elementProps}
    >
      {headlineText && (
        <Text as="h3">{headlineText}</Text>
      )}
      {item_text && (
        <Text>{item_text}</Text>
      )}
    </Element>
  )
}

export default TwoColumnItem
